import { Link as NavLink } from "@react-navigation/native/";
import { Text } from "tamagui";

type To<
  ParamList extends
    ReactNavigation.RootParamList = ReactNavigation.RootParamList,
  RouteName extends keyof ParamList = keyof ParamList,
> =
  | RouteName
  | (undefined extends ParamList[RouteName]
      ? {
          screen: Extract<RouteName, string>;
          params?: ParamList[RouteName];
        }
      : {
          screen: Extract<RouteName, string>;
          params: ParamList[RouteName];
        });

export const Link = ({
  to,
  children,
}: {
  to: To;
  children: JSX.Element | string;
}) => {
  return (
    // @ts-expect-error
    <NavLink to={typeof to === "string" ? { screen: to } : to}>
      <Text
        flex={1}
        color="$color"
        fontFamily="$label"
        cursor="pointer"
        textDecorationLine="underline"
        hoverStyle={{
          color: "$muted",
        }}
      >
        {children}
      </Text>
    </NavLink>
  );
};
